import { create } from "zustand";
import { persist } from "zustand/middleware";

interface InviteState {
  inviteCode: string | null;
  setInviteCode: (code: string | null) => void;
  clearInviteCode: () => void;
}

const useInviteStore = create<InviteState>()(
  persist(
    (set) => ({
      inviteCode: null,
      setInviteCode: (code) => set({ inviteCode: code }),
      clearInviteCode: () => set({ inviteCode: null }),
    }),
    {
      name: "invite-storage", // unique name for localStorage key
    },
  ),
);

export default useInviteStore;
